module.exports = __webpack_public_path__ + "media/images/check-icon-blue-0949fb28.svg";